import * as Yup from "yup";
import { isValidDate, validateDateMax, validateDateMin } from "../../../helpers";
import i18n from "i18next";

export const sirenRegExp = new RegExp(
    /^[0-9]{9}$/
);

export const firstNameValidation = () => Yup.object().shape({
  firstName: Yup.string().required(i18n.t("signinpage:firstName.error.required")),
})

export const surNameValidation = () => Yup.object().shape({
  surName: Yup.string().required(i18n.t("signinpage:surName.error.required")),
})

export const dateOfBirthValidation = () => Yup.object().shape({
  dateOfBirth: Yup.string()
    .test("isValidDate", i18n.t("signinpage:dateOfBirth.error.wrongFormat"), function (item) {
        return Boolean(item && isValidDate(item));
    })
    .test("MinDate", i18n.t("signinpage:dateOfBirth.error.minDate"), function (item) {
        return Boolean(item && validateDateMin(item));
    })
    .test("maxDate", i18n.t("signinpage:dateOfBirth.error.maxDate"), function (item) {
        return Boolean(item && validateDateMax(item));
    })
    .required(i18n.t("signinpage:dateOfBirth.error.required")),
})

export const sirenValidation = () => Yup.object().shape({
  siren: Yup.string()
    .matches(sirenRegExp, i18n.t("signinpage:siren.error.wrongFormat"))
    .required(i18n.t("signinpage:siren.error.required")),
})

export const customerNumberValidation = () => Yup.object().shape({
  customerNumber: Yup.string()
    .min(8, i18n.t("signinpage:customerNumber.error.wrongFormat"))
    .max(10, i18n.t("signinpage:customerNumber.error.wrongFormat"))
    .required(i18n.t("signinpage:customerNumber.error.required")),
})

export const companyNameValidation = () => Yup.object().shape({
  companyName: Yup.string().required(i18n.t("signinpage:companyName.error.required")),
})
